import { Effect, Schema } from "effect";
import { HttpClient, type HttpClientResponse } from "effect/unstable/http";
import { HttpApi, HttpApiClient } from "effect/unstable/httpapi";
import { ResourceApi, ResourcePublicFailureBody } from "@workerstation/shared/resources/http";
import { ResourceRequestError, resourceUnavailable, type ResourceFailure } from "@workerstation/shared/errors/resource";

const Api = HttpApi.make("FrontendResourceControlApi").add(ResourceApi);
const Envelope = Schema.Struct({ error: Schema.optionalKey(Schema.Json) });
const publicRefusal = (response: HttpClientResponse.HttpClientResponse) => {
  const status = response.status;
  if (status !== 400 && status !== 404 && status !== 409) return Effect.fail(resourceUnavailable());
  return response.json.pipe(Effect.flatMap(Schema.decodeUnknownEffect(ResourcePublicFailureBody)), Effect.mapError(() => resourceUnavailable()), Effect.flatMap(body => Effect.fail(new ResourceRequestError({ status, message: body.error, ...(body.available === undefined ? {} : { available: body.available }) }))));
};

export const ownResourceRequest = <A, E, R>(operation: Effect.Effect<A, E, R>) => Effect.scoped(operation.pipe(
  Effect.mapError((error): ResourceFailure => Schema.is(ResourceRequestError)(error) ? error : resourceUnavailable())
));

export const makeResourceControlClient = Effect.fn("Frontend.ResourceControlApi.make")(function* (baseUrl: string) {
  const http = HttpClient.withScope(yield* HttpClient.HttpClient);
  const json = HttpClient.transformResponse(http, response => response.pipe(
    Effect.mapError(() => resourceUnavailable()),
    Effect.flatMap(value => value.status >= 200 && value.status < 300 ? value.json.pipe(
      Effect.flatMap(Schema.decodeUnknownEffect(Envelope)), Effect.mapError(() => resourceUnavailable()),
      Effect.flatMap(body => body.error ? Effect.fail(resourceUnavailable()) : Effect.succeed(value))
    ) : publicRefusal(value))
  ));
  return yield* HttpApiClient.makeWith(Api, { httpClient: json, baseUrl });
});
